import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Components/layout/Header';
import Footer from '../Components/layout/Footer';
import BottomNavigation from '../Components/layout/BottomNavigation';

const MainLayout: React.FC = () => {
  return (
    <div className="website-layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      <BottomNavigation />
    </div>
  );
};

export default MainLayout;
